import './scss/main.scss'
import './scss/custom.scss'

import { createApp } from 'vue'
import App from './App.vue'
import { createVuestic } from 'vuestic-ui'

import stores from './stores'
import router from './router'
import i18n from './i18n'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

const app = createApp(App)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(router)
app.use(stores)
app.use(i18n)

app.mount('#app')
